import { inject, observer } from 'mobx-react';
import React from 'react';

import { AprobacionStore } from '../../stores';

import { Button } from 'antd';

interface BotonesAprobacionProps {
    aprobacionStore?: AprobacionStore;
    handleAceptar: () => void;
    handleRechazar: () => void;
}

@inject('aprobacionStore')
@observer
export class BotonesAprobacion extends React.Component<BotonesAprobacionProps, {}> {
    render() {
        const stylePrimary = {
            backgroundColor:'#a8123e', borderColor:'#a8123e'
        };
        const styleVeda = {
            backgroundColor:'#3c3c3b', borderColor:'#3c3c3b'
        };
        const { hasComments } = this.props.aprobacionStore!;
        return (
            <div>
                <Button type="danger" onClick={this.props.handleRechazar} disabled={!hasComments}>
                    Rechazar
                </Button>
                <Button
                    type="primary"
                    onClick={this.props.handleAceptar}
                    style={{...styleVeda,float:'right'}}
                >
                    Aceptar
                </Button>
            </div>
        );
    }
}

export default BotonesAprobacion;
